import script from "./StoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoryCard.vue?vue&type=script&setup=true&lang=ts"

import "./StoryCard.vue?vue&type=style&index=0&id=cde2a976&lang=scss"

const __exports__ = script;

export default __exports__